/* eslint-disable sonarjs/cognitive-complexity */
/****************************************************************************
 * COPYRIGHT (c) 2024 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import PropTypes from "prop-types";
import {
  TextField,
  Typography,
  Container,
  Box,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Modal from "@mui/material/Modal";
import { useNavigate, useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import iconButton from "../../assets/images/Icon_Button.png";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CloseIcon from "@mui/icons-material/Close";
import { putSubmissionDetails } from "../../Services/redux/Application-details/ApplicationDetailsActions";
import { checkDsaMissingInfo, triggerDsaMissingInfoPopup } from "../../Services/redux/dsa-review/DSAReviewActions";
import { getConfig } from "../../config";
import ApproveApplicationPopUp from "../ApproveApplicationPopUp/ApproveApplicationPopUp";
import "./ListingHeader.css";
import APIManager from "../../Services/ApiManager/ApiManager";
import PopupDialog from "../../Components/PopupDialog";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

function ListingHeader({
  checkAll,
  callPostSubmissionRequest,
  calPostApplicationNewRelase,
  postCallTheNewSubmission,
  createNewRelase,
}) {
  const { appId, submissionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ✅ Helper function to determine navigation behavior for Group Apps actions
  const getGroupAppsNavigationConfig = () => {
    const currentStatus = sessionStorage.getItem(
      "domain-approver-activeStatus"
    );

    // For Group Apps actions (Relist, Delist) - always persist current status
    return {
      shouldPersistStatus: true,
      targetStatus: currentStatus || "SUBMITTED_FOR_PRODUCTION",
    };
  };
  const submissionData = useSelector(
    (state) => state.submissionDetails.submissionDetails
  );
  const appData = useSelector(
    (state) => state.applicationDetails.applicationDetails
  );
  const allSubmissionsData = useSelector(
    (state) => state.applicationAllSubmissions.submissions
  );
  const fetchappList = useSelector(
    (state) => state.contentAppList.contentDetails
  );
  const licensingActionsBoolean = useSelector(
    (state) => state.licenseReducer.licensingActions
  );
  const dsaReviewed = useSelector((state) => state.dsaReview.dsaReviewed);
  const readOnly_GlobalAdmin =
    sessionStorage.getItem("readonly_GlobalAdmin") === "true";
  const [reactEuropeanCountries, setReactEuropeanCountries] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openAutoPublishDialog, setOpenAutoPublishDialog] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [openDelistDialog, setOpenDelistDialog] = React.useState(false);
  const [openDsaDialog, setOpenDsaDialog] = React.useState(false);
  const [openPopuModal, setOpenPopuModal] = useState(false);
  const [delistReason, setDelistReason] = useState(null);
  const [forceInstall, setForceInstall] = useState(false);
  const [dsaComplaint, setDsaComplaint] = useState(false);
  const [isRelease, setIsRelease] = useState(false);
  const [applicationName, setApplicationName] = useState("");
  const [europeanCountries, setEuropeanCountries] = useState(false);
  const [submitText, setSubmitText] = useState("");
  const [titleModalPopup, setTitleModalPopup] = useState("");
  const [nextReviewStatus, setNextReviewStatus] = useState("");
  const [isLatestSubmission, setIsLatestSubmission] = useState(false);
  const thirdPartyApps = globalThis.location.href.includes("third-party-apps");
  const [openApkValidateButton, setOpenApkValidateButton] = useState(false);
  const [loader, setLoader] = useState(false);
  const [componentName, setComponentName] = useState("");
  const [openErrorPopup, setOpenErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [headerMessage, setHeaderMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const open = Boolean(anchorEl);
  const handleMoreOptionsClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenApkValidateButton(true);
  };
  const handleMoreOptionsClose = () => {
    setAnchorEl(null);
    setOpenApkValidateButton(false);
  };

  const handleValidateClick = () => {
    setOpenApkValidateButton(false);
    APIManager.putApkValidation(appId, submissionId)
      .then((response) => {
        setSnackbarMessage("Application validation completed successfully");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        setComponentName("appError");
        setErrorMessage(error.message);
        setHeaderMessage(
          error.message === "jwt expired" ? "401 Token Expired" : "Error"
        );
        setOpenErrorPopup(true);
      });
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const PaymentID = submissionData.paymentSellerId;
  const payload = (cognitoResponse) => {
    const payloadData = {
      appImageUrl: appData.iconUrl,
      appName: appData.name,
      appVersion: allSubmissionsData.versionName,
      publishSellerName: cognitoResponse?.results[0]?.firstName,
      publisherAppId: appData.id,
      toAddress: cognitoResponse?.results[0]?.email,
    };
    return payloadData;
  };
  const developerEmail = (cognitoResponse) => {
    return cognitoResponse.toAddress || "developer";
  };

  useEffect(() => {
    const currentURL = globalThis.location.href;
    setIsRelease(currentURL.includes("releases"));
    setReactEuropeanCountries([...getConfig().REACT_APP_EUROPEAN_COUNTRIES]);

    // Load application name from localStorage on component mount
    const storedAppName = localStorage.getItem("currentApplicationName");
    if (storedAppName) {
      setApplicationName(storedAppName);
    }
  }, []);

  useEffect(() => {
    if (checkAll) {
      setDisableButton(false);
    } else {
      setDisableButton(true);
    }
  }, [checkAll]);

  useEffect(() => {
    if (allSubmissionsData && allSubmissionsData.length > 0) {
      const versionCodesOfAllSubmissions = allSubmissionsData.map((release) => {
        return release.versionCode;
      });
      let max_versionCode = Math.max(...versionCodesOfAllSubmissions);
      let latestVersion = allSubmissionsData.filter(
        (appVersion) => appVersion.versionCode === max_versionCode
      );

      if (
        latestVersion.length != 0 &&
        latestVersion[0].id === submissionData?.id
      ) {
        setIsLatestSubmission(true);
      } else {
        setIsLatestSubmission(false);
      }
    }
  }, [allSubmissionsData, submissionData]);

  const handleNotifyDeveloper = () => {
    setLoader(true);
    APIManager.getGlobalAdminPublisherInfoCognito(PaymentID)
      .then((response) => {
        const payloadData = payload(response);
        return APIManager.postNotifyDeveloper(payloadData);
      })
      .then((response) => {
        setLoader(false);

        const developerEmailData = developerEmail(response);
        setSnackbarMessage(
          `Email has been successfully sent to ${developerEmailData}`
        );
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error("Error posting data:", error);
        setComponentName("appError");
        setErrorMessage(error.message);
        setHeaderMessage(
          error.message === "jwt expired" ? "401 Token Expired" : "Error"
        );
        setOpenErrorPopup(true);
        setLoader(false);
        setSnackbarMessage("Failed to send email notification");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      });
  };
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleCancel = () => {
    setOpenDelistDialog(false);
  };

  const handleDsaCancel = () => {
    setOpenDsaDialog(false);
    setDsaComplaint(false);
  };

  const showDialog = () => {
    setOpenDelistDialog(true);
    setDelistReason(null);
  };

  const handlePopupModalClose = () => {
    setOpenPopuModal(false);
  };

  const handleAutoPublishOpen = () => {
    setOpenAutoPublishDialog(true);
  };

  const handleAutoPublishClose = () => {
    setOpenAutoPublishDialog(false);
  };

  const handleAutoPublishProceed = () => {
    let actionType;
    if (
      getConfig().REACT_APP_PORTAL === "domain-approver" ||
      getConfig().REACT_APP_PORTAL === "global-admin"
    ) {
      if (submissionData.status === "IN_REVIEW") {
        actionType = "Approve for Production";
      } else if (submissionData.status === "SUBMITTED_FOR_STAGING") {
        actionType = "Approve for Staging";
      }
    } else {
      actionType = "Approve for Staging";
    }
    openModalPopUp(actionType);
    setOpenAutoPublishDialog(false);
  };

  const openModalPopUp = (text) => {
    setTitleModalPopup(text);
    switch (text) {
      case "Approve for Production":
        if (getConfig().REACT_APP_PORTAL === "oem-admin")
          setNextReviewStatus("PRODUCTION_APPROVAL_APPROVED");
        else setNextReviewStatus("approve_production");

        break;
      case "Reject for Production":
        if (getConfig().REACT_APP_PORTAL === "oem-admin")
          setNextReviewStatus("REJECTED_AT_PRODUCTION");
        else setNextReviewStatus("reject_production");

        break;
      case "Approve for Staging":
        if (getConfig().REACT_APP_PORTAL === "oem-admin")
          setNextReviewStatus("STAGING_APPROVAL_APPROVED");
        else setNextReviewStatus("approve_staging");
        break;
      case "Reject for Staging":
        if (getConfig().REACT_APP_PORTAL === "oem-admin") {
          setNextReviewStatus("REJECTED_AT_STAGING");
        } else {
          setNextReviewStatus("reject_staging");
        }
        break;
      case "Delist from Production":
        setNextReviewStatus("DELIST_AT_PRODUCTION");
        break;
      case "Approve for Closed Beta":
        setNextReviewStatus("APPROVED_FOR_CLOSED_BETA");
        break;
      case "Delist from Staging":
        setNextReviewStatus("DELIST_AT_STAGING");
        break;
      case "REJECTED_BY_DOMAIN_APPROVER":
        setNextReviewStatus("REJECTED_BY_DOMAIN_APPROVER");
        break;
      case "Domain Approval Approved":
        setNextReviewStatus("DOMAIN_APPROVAL_APPROVED");
        break;
      case "Domain Approval In Review":
        setNextReviewStatus("DOMAIN_APPROVAL_IN_REVIEW");
        break;
      case "Move to In-Review":
        if (submissionData.reviewStatus === "PRODUCTION_APPROVAL_IN_REVIEW") {
          setNextReviewStatus("PRODUCTION_APPROVAL_IN_REVIEW");
        } else if (
          submissionData.reviewStatus === "STAGING_APPROVAL_IN_REVIEW"
        ) {
          setNextReviewStatus("STAGING_APPROVAL_IN_REVIEW");
        }
        break;
      default:
        break;
    }
    setOpenPopuModal(true);
  };

  const handleChangeDelistValue = ($event) => {
    setDelistReason($event.target.value);
  };

  const handleForceInstallAll = ($event) => {
    setForceInstall($event.target.checked);
  };
  const handleDsaomplaint = ($event) => {
    setDsaComplaint($event.target.checked);
    let newSubmissionData = {
      ...submissionData,
      isDSACompliant: $event.target.checked,
    };
    delete newSubmissionData["legalDocuments"];
    if (getConfig().REACT_APP_PORTAL === "seller") {
      postCallTheNewSubmission(newSubmissionData);
    } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
      dispatch(putSubmissionDetails(appId, submissionId, newSubmissionData));
    } 
  };

  const availableActions = {
    SUBMIT_FOR_PRODUCTION: "Submit For Production",
    SUBMITTED_FOR_PRODUCTION: "Submitted for Production",
    SUBMITTED_FOR_STAGING: "Submitted for Staging",
    CANCEL_FOR_PRODUCTION: "Cancel For Production",
    SUBMIT_FOR_BETA: "Submit For Beta",
    SUBMIT_FOR_STAGING: "Submit For Staging",
    REVOKE_FOR_BETA: "Revoke For Beta",
    REVOKE_FOR_STAGING: "Revoke For Staging",
    REVOKE_FOR_PRODUCTION: "Revoke For Production",
    CANCEL_FOR_STAGING: "Cancel For Staging",
    DELETE: "Delete",
    DELIST: "Delist",
    PUBLISHED: "Published",
    DRAFT: "Draft",
    RELIST: "Relist",
    PUBLISH: "Publish",
    ROLLBACK_TO_DRAFT: "Rollback to draft",
    DELISTED_BY_SELLER: "Delisted by Seller",
    REJECTED_FOR_PRODUCTION: "Rejected for Production",
    APPROVED_FOR_PRODUCTION: "Approved for Production",
    IN_REVIEW: "In Review",
    GENERATING_DELTA: "Generating Delta",
    DELISTED_BY_ADMIN: "Delisted by Admin",
    APPROVED_FOR_BETA: "Approved for Beta",
    APPROVED_FOR_STAGING: "Approved for Staging",
    DELISTED_BY_APPROVER: "Delisted By Approver",
  };

  useEffect(() => {
    if (appData && Object.keys(appData).length > 0 && appData.name) {
      const displayName =
        appData.name.length > 20 ? appData.name.substring(0, 20) : appData.name;
      setApplicationName(displayName);
      // Store in localStorage
      localStorage.setItem("currentApplicationName", displayName);
    }
  }, [appData]);

  useEffect(() => {
    if (submissionData && Object.keys(submissionData).length > 0) {
      submissionData.status === "DRAFT" && !checkAll
        ? setDisableButton(true)
        : setDisableButton(false);

      // Set application name from submissionData if appData is not available
      if (
        !appData?.name &&
        submissionData.descriptions &&
        submissionData.descriptions.length > 0 &&
        submissionData.descriptions[0].applicationName
      ) {
        const displayName =
          submissionData.descriptions[0].applicationName.length > 20
            ? submissionData.descriptions[0].applicationName.substring(0, 20)
            : submissionData.descriptions[0].applicationName;
        setApplicationName(displayName);
        // Store in localStorage
        localStorage.setItem("currentApplicationName", displayName);
      }

      // *****************Old change*******************************
      if (
        getConfig().REACT_APP_PORTAL !== "oem-admin" &&
        getConfig().REACT_APP_PORTAL !== "domain-approver" &&
        submissionData.targeting.countriesInclusions.length > 0 &&
        reactEuropeanCountries &&
        reactEuropeanCountries.length > 0
      ) {
        let checkEurope = false;
        // ***************** Till here*******************************

        // *****************Incoming change*******************************
        // ***************** Till here*******************************
        for (
          const countryInclusion of submissionData.targeting.countriesInclusions
        ) {
          const index = reactEuropeanCountries.indexOf(countryInclusion);
          if (index >= 0) {
            checkEurope = true;
            setEuropeanCountries(true);
            break;
          }
        }
        if (!checkEurope) {
          setEuropeanCountries(false);
        }
      }
    }

    // Handle application name from fetchappList (this takes priority)
    if (
      fetchappList &&
      Object.keys(fetchappList).length > 0 &&
      fetchappList.portfolioContents &&
      fetchappList.portfolioContents.length > 0 &&
      submissionData?.id
    ) {
      const foundContent = fetchappList.portfolioContents.find(
        (ele) => ele.id === submissionData.id
      );
      if (foundContent?.title) {
        const displayName =
          foundContent.title.length > 20
            ? foundContent.title.substring(0, 20)
            : foundContent.title;
        setApplicationName(displayName);
        // Store in localStorage
        localStorage.setItem("currentApplicationName", displayName);
      }
      //commented this code to fix merge conflicts as it was doing the same work like above find code
      //       ? setApplicationName(ele.title.substring(0, 20))
      //       : setApplicationName(ele.title);
      //   }
      // });
    } else if (
      getConfig().REACT_APP_PORTAL === "domain-approver" &&
      thirdPartyApps &&
      submissionData?.descriptions
    ) {
      setApplicationName(submissionData.descriptions[0].applicationName);
    }
  }, [submissionData, fetchappList, reactEuropeanCountries, appData]);

  let imageSrc = submissionData?.icon?.url;
  if (
    getConfig().REACT_APP_PORTAL === "oem-admin" ||
    (getConfig().REACT_APP_PORTAL === "domain-approver" &&
      !submissionData?.isOemApp)
  ) {
    imageSrc = submissionData?.icon;
  }
  if (
    getConfig().REACT_APP_PORTAL === "seller" ||
    (getConfig().REACT_APP_PORTAL === "domain-approver" &&
      !globalThis.location.href.includes("third-party-apps"))
  ) {
    imageSrc = submissionData?.icon?.url;
  }

 const callPossibleActions = async (action) => {
  switch (action) {
    case "SUBMIT_FOR_PRODUCTION":
      if (europeanCountries && dsaReviewed === false) {
        dispatch(checkDsaMissingInfo(true, true));
      } else if (europeanCountries) {
        setSubmitText("Submit For Production");
        setDsaComplaint(false);
        setOpenDsaDialog(true);
      } else {
        await callPostSubmissionRequest("submit_production");
        navigate(`/ui/developer/applications`);
      }
      break;
    case "CANCEL_FOR_PRODUCTION":
      await callPostSubmissionRequest("cancel_production");
      navigate(`/ui/developer/applications`);
      break;
    case "DELIST":
      showDialog();
      break;
    case "RELIST":
      if (getConfig().REACT_APP_PORTAL === "seller") {
        await callPostSubmissionRequest("relist");
        navigate(`/ui/developer/applications`);
      } else if (getConfig().REACT_APP_PORTAL === "domain-approver") {
        try {
          await APIManager.sendSubmissionForProductionRelistAndReview(
            appId,
            submissionId,
            "relist"
          );
          sessionStorage.setItem("domain-approver-selectedTab", "0");
          const currentStatus =
            sessionStorage.getItem("domain-approver-activeStatus") ||
            "SUBMITTED_FOR_PRODUCTION";
          navigate(`/ui/domain-approver/applications`, {
            replace: true,
            state: {
              refresh: Date.now(),
              selectedTab: 0,
              persistStatus: currentStatus,
            },
          });
        } catch (error) {
          console.error("Error occurred while relisting:", error);
        }
      } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
        try {
          await APIManager.sendSubmissionForProductionRelistAndReview(
            appId,
            submissionId,
            "relist"
          );
          navigate(`/ui/harman-admin/applications`);
        } catch (error) {
          console.error("Error sending submission for production:", error);
        }
      }
      break;
    case "CREATE_NEW_RELEASE":
      calPostApplicationNewRelase();
      break;
    case "DELETE":
      await callPostSubmissionRequest("delete");
      navigate(`/ui/developer/applications`);
      break;
    case "SUBMIT_FOR_BETA": {
        const isOemSellerUser = sessionStorage.getItem("isOemSeller") === "true";
        const isVwSellerUser = sessionStorage.getItem("idpLogin") === "true";
        if ((isOemSellerUser || isVwSellerUser || europeanCountries) && dsaReviewed === true) {
        setSubmitText("Submit For Beta");
        setDsaComplaint(false);
        setOpenDsaDialog(true);
      } else if (isOemSellerUser || isVwSellerUser || europeanCountries) {
        dispatch(triggerDsaMissingInfoPopup());
      } else {
        await callPostSubmissionRequest("submit_beta");
        navigate(`/ui/developer/applications`);
      }
      break;
    }
    case "SUBMIT_FOR_STAGING": {
        const isOemSellerUser = sessionStorage.getItem("isOemSeller") === "true";
        const isVwSellerUser = sessionStorage.getItem("idpLogin") === "true";
        if ((isOemSellerUser || isVwSellerUser || europeanCountries) && dsaReviewed === true) {
        setSubmitText("Submit For Staging");
        setDsaComplaint(false);
        setOpenDsaDialog(true);
      } else if (isOemSellerUser || isVwSellerUser || europeanCountries) {
        dispatch(triggerDsaMissingInfoPopup());
      } else {
        await callPostSubmissionRequest("submit_staging");
        navigate(`/ui/developer/applications`);
      }
      break;
    }
    case "REVOKE_FOR_BETA":
      await callPostSubmissionRequest("revoke_beta");
      navigate(`/ui/developer/applications`);
      break;
    case "REVOKE_FOR_STAGING":
      await callPostSubmissionRequest("revoke_staging");
      navigate(`/ui/developer/applications`);
      break;
    case "CANCEL_FOR_STAGING":
      await callPostSubmissionRequest("cancel_staging");
      navigate(`/ui/developer/applications`);
      break;
    case "PUBLISH":
      if (getConfig().REACT_APP_PORTAL === "seller") {
        await callPostSubmissionRequest("publish");
        navigate(`/ui/developer/applications`);
      } else if (getConfig().REACT_APP_PORTAL === "domain-approver") {
        showDialog();
        break;
      }
      break;
    case "ROLLBACK_TO_DRAFT":
      await callPostSubmissionRequest("rollback_to_draft");
      break;
    case "REVOKE_FOR_PRODUCTION":
      try {
        await callPostSubmissionRequest("revoke_production");
          // ✅ Navigate to Group Apps and persist current status for Delist action
        const navigationConfig = getGroupAppsNavigationConfig();
        sessionStorage.setItem("domain-approver-selectedTab", "0");
        sessionStorage.setItem(
          "domain-approver-activeStatus",
          navigationConfig.targetStatus
        );
        navigate("/ui/domain-approver/applications", {
          replace: true,
          state: {
            refresh: Date.now(),
            selectedTab: 0,
            fromContext: "groupAppsAction",
          },
        });
      } catch (error) {
        console.error("Error occurred while revoking:", error);
      }
      break;
    case "IN_REVIEW":
      if (getConfig().REACT_APP_PORTAL === "global-admin") {
        try {
          await APIManager.sendSubmissionForProductionRelistAndReview(
            appId,
            submissionId,
            "review"
          );
          navigate(`/ui/harman-admin/applications`);
        } catch (error) {
          console.error("Error sending submission for production:", error);
        }
      } else if (getConfig().REACT_APP_PORTAL === "domain-approver") {
        try {
          await APIManager.sendSubmissionForProductionRelistAndReview(
            appId,
            submissionId,
            "review"
          );
            // ✅ Navigate to Group Apps and persist current status for IN_REVIEW action
          const navigationConfig = getGroupAppsNavigationConfig();
          sessionStorage.setItem("domain-approver-selectedTab", "0");
          sessionStorage.setItem(
            "domain-approver-activeStatus",
            navigationConfig.targetStatus
          );
          navigate(`/ui/domain-approver/applications`, {
            replace: true,
            state: {
              refresh: Date.now(),
              selectedTab: 0,
              fromContext: "groupAppsAction",
            },
          });
        } catch (error) {
          console.error("Error occured", error);
            // ✅ Navigate to Group Apps and persist current status even on error
          const navigationConfig = getGroupAppsNavigationConfig();
          sessionStorage.setItem("domain-approver-selectedTab", "0");
          sessionStorage.setItem(
            "domain-approver-activeStatus",
            navigationConfig.targetStatus
          );
          navigate(`/ui/domain-approver/applications`, {
            replace: true,
            state: {
              refresh: Date.now(),
              selectedTab: 0,
              fromContext: "groupAppsAction",
            },
          });
        }
      }

      break;
    default:
      navigate(`/ui/developer/applications`);
      break;
  }
};

  const callDelist = async () => {
    if (getConfig().REACT_APP_PORTAL === "seller") {
      callPostSubmissionRequest("delist", forceInstall);
      setOpenDelistDialog(false);
      navigate(`/ui/developer/applications`);
    } else if (getConfig().REACT_APP_PORTAL === "domain-approver") {
      try {
       await APIManager.sendSubmissionForProductionDelistAndRelist(
          appId,
          submissionId,
          "delist",
          forceInstall
        );
        setOpenDelistDialog(false);
        // Navigate to Group Apps tab and persist current status
        sessionStorage.setItem("domain-approver-selectedTab", "0");
        const currentStatus =
          sessionStorage.getItem("domain-approver-activeStatus") ||
          "SUBMITTED_FOR_PRODUCTION";
        navigate("/ui/domain-approver/applications", {
          replace: true,
          state: {
            refresh: Date.now(),
            selectedTab: 0,
            persistStatus: currentStatus,
          },
        });
      } catch (error) {
        console.error("Error occurred while delisting:", error);
      }
    } else if (getConfig().REACT_APP_PORTAL === "global-admin") {
      try {
        await APIManager.sendSubmissionForProductionDelistAndRelist(
          appId,
          submissionId,
          "delist",
          forceInstall
        );
        navigate(`/ui/harman-admin/applications`);
      } catch (error) {
        console.error("Error sending submission for production:", error);
      }
    }
  };

  const callDsaComplaintSubmit = async () => {
    if (getConfig().REACT_APP_PORTAL === "seller") {
      switch (submitText) {
        case "Submit For Production":
        await  callPostSubmissionRequest("submit_production");
          break;
        case "Submit For Beta":
        await  callPostSubmissionRequest("submit_beta");
          break;
        case "Submit For Staging":
        await  callPostSubmissionRequest("submit_staging");
          break;
        default:
          break;
      }
      setOpenDelistDialog(false);
      navigate(`/ui/developer/applications`);
    } 
  };
console.log("Submission data listing header", submissionData)
  return (
    <Container maxWidth="lg">
      <Backdrop
        open={loader}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: "#fff" }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container justifyContent="flex-start">
        <Grid size={12}>
          <section className="listing-header-container">
            {submissionData && Object.keys(submissionData).length > 0 && (
              <div
                className="container-header-icons"
                style={
                  submissionData.status === "DRAFT"
                    ? { width: "94%" }
                    : { width: "100%" }
                }
              >
                <div className="app-icon" style={{ marginLeft: "10%" }}>
                  <div className="icon-name">
                    <img
                      src={imageSrc}
                      alt={
                        submissionData.fileName
                          ? submissionData.fileName
                          : applicationName || "Application"
                      }
                      className="submission-header-icon"
                      width={80}
                      height={80}
                      style={{
                        border: "1px solid  #FFFFFF66",
                        borderRadius: "4px",
                      }}
                    />
                    {
                      <div className="name-status">
                        <Typography
                          title={appData.name}
                          className="application-name"
                        >
                          {applicationName}
                        </Typography>
                        {getConfig().REACT_APP_PORTAL === "seller" ||
                        getConfig().REACT_APP_PORTAL === "global-admin" ||
                        (getConfig().REACT_APP_PORTAL === "domain-approver" &&
                          !thirdPartyApps) ? (
                          <Typography
                            title={appData.name}
                            className="content-version-div"
                          >
                            {submissionData.name}
                          </Typography>
                        ) : (
                          (getConfig().REACT_APP_PORTAL === "oem-admin" ||
                            (getConfig().REACT_APP_PORTAL ===
                              "domain-approver" &&
                              thirdPartyApps)) && (
                            <Typography
                              title={appData.name}
                              className="content-version-div"
                            >
                              {submissionData.contentVersion}
                            </Typography>
                          )
                        )}

                        {!isRelease && (
                          <Chip
                            className="chip-status"
                            label={availableActions[submissionData.status]}
                            sx={{
                              height: "24px",
                              backgroundColor: () => {
                                switch (submissionData.status) {
                                  case "APPROVED_FOR_PRODUCTION":
                                    return "#9ccaf6";
                                  case "SUBMIT_FOR_PRODUCTION":
                                    return "#9ccaf6";
                                  case "SUBMITTED_FOR_PRODUCTION":
                                    return "#9ccaf6";
                                  case "SUBMITTED_FOR_STAGING":
                                    return "#9ccaf6";
                                  case "PUBLISHED":
                                    return "#98f0c8";
                                  case "DRAFT":
                                    return "#e8e8e8";
                                  case "REJECTED_FOR_PRODUCTION":
                                    return "#fbc2bc";
                                  case "APPROVED_FOR_BETA":
                                    return "#9ccaf6";
                                  case "APPROVED_FOR_STAGING":
                                    return "#9ccaf6";
                                  case "REJECTED_FOR_STAGING":
                                    return "#fbc2bc";
                                  case "DELISTED_BY_SELLER":
                                    return "#fbc2bc";
                                  case "DELISTED_BY_ADMIN":
                                    return "#fbc2bc";
                                  case "IN_REVIEW":
                                    return "#ffe898";
                                  case "GENERATING_DELTA":
                                    return "#ffe898";
                                  default:
                                    return "#e8e8e8";
                                }
                              },
                              color: () => {
                                switch (submissionData.status) {
                                  case "APPROVED_FOR_PRODUCTION":
                                    return "#02315d";
                                  case "SUBMIT_FOR_PRODUCTION":
                                    return "#02315d";
                                  case "SUBMITTED_FOR_PRODUCTION":
                                    return "#02315d";
                                  case "SUBMITTED_FOR_STAGING":
                                    return "#02315d";
                                  case "PUBLISHED":
                                    return "#00562d";
                                  case "DRAFT":
                                    return "#2a2c2d";
                                  case "REJECTED_FOR_PRODUCTION":
                                    return "#b50b00";
                                  case "APPROVED_FOR_BETA":
                                    return "#02315d";
                                  case "APPROVED_FOR_STAGING":
                                    return "#02315d";
                                  case "REJECTED_FOR_STAGING":
                                    return "#b50b00";
                                  case "DELISTED_BY_SELLER":
                                    return "#b50b00";
                                  case "DELISTED_BY_ADMIN":
                                    return "#b50b00";
                                  case "IN_REVIEW":
                                    return "#663800";
                                  case "GENERATING_DELTA":
                                    return "#663800";
                                  default:
                                    return "#2a2c2d";
                                }
                              },
                            }}
                          ></Chip>
                        )}
                      </div>
                    }
                  </div>
                </div>
                {!isRelease && (
                  <div className="submit-buttons">
                    <Stack direction="row" spacing={"8px"}>
                      {(submissionData.status === "PUBLISHED" ||
                        submissionData.status === "DELISTED_BY_SELLER" ||
                        submissionData.status === "APPROVED_FOR_BETA" ||
                        submissionData.status === "APPROVED_FOR_PRODUCTION" ||
                        submissionData.status === "REJECTED_FOR_PRODUCTION" ||
                        submissionData.status === "APPROVED_FOR_STAGING") &&
                        getConfig().REACT_APP_PORTAL === "seller" && (
                          <Button
                            className={`custom-button submitted_button`}
                            sx={{
                              width: "max-content",
                              height: "max-content",
                              maxWidth: "100%",
                              textTransform: "none",
                              // paddingLeft: "10px !important",
                              // paddingRight: "10px !important",
                              // paddingTop: "0px !important",
                              // paddingBottom: "0px !important",
                            }}
                            variant="outlined"
                            onClick={() =>
                              callPossibleActions("CREATE_NEW_RELEASE")
                            }
                          >
                            Create New Release
                          </Button>
                        )}
                      {getConfig().REACT_APP_PORTAL === "seller" &&
                        submissionData?.availableActions &&
                        submissionData.availableActions.length > 0 &&
                        submissionData.availableActions.map((action, index) => {
                          const clasNameStyle =
                            action === "DELETE"
                              ? "delete_button"
                              : "submitted_button";
                          return (action === "SUBMIT_FOR_PRODUCTION" ||
                            action === "SUBMIT_FOR_BETA" ||
                            action === "SUBMIT_FOR_STAGING") &&
                            submissionData.status === "DRAFT" ? (
                            <Button
                              className={`custom-button ${clasNameStyle}`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                backgroundColor: "#1976d2 !important",
                                color: "#fff !important",
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  // border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              key={action}
                              variant="outlined"
                              disabled={
                                disableButton || licensingActionsBoolean
                              }
                              onClick={() => callPossibleActions(action)}
                            >
                              {action === "SUBMIT_FOR_PRODUCTION"
                                ? "Submit For Production"
                                : "Submit For Beta"}
                            </Button>
                          ) : (
                            action !== "REVOKE_FOR_PRODUCTION" &&
                              action !== "REVOKE_FOR_STAGING" &&
                              action !== "REVOKE_FOR_BETA" && (
                                <Button
                                  className={`custom-button ${clasNameStyle}`}
                                  style={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    maxWidth: "100%",
                                    textTransform: "none",
                                  }}
                                  key={`${action}-alt`}
                                  variant="outlined"
                                  sx={{
                                    "&.Mui-disabled": {
                                      // color: 'rgba(0, 0, 0, 0.26) !important',
                                      // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                      border:
                                        "1px solid rgba(181, 11, 0, 1) !important",
                                      color: "rgba(181, 11, 0, 1) !important",
                                      opacity: 0.5,
                                    },
                                  }}
                                  disabled={
                                    appData &&
                                    submissionData &&
                                    Object.keys(submissionData).length > 0 &&
                                    appData.submissions &&
                                    (submissionData.status === "PUBLISHED" ||
                                      (submissionData.status === "DRAFT" &&
                                        !createNewRelase) ||
                                      submissionData.status ===
                                        "APPROVED_FOR_BETA" ||
                                      submissionData.status ===
                                        "APPROVED_FOR_STAGING" ||
                                      submissionData.status ===
                                        "APPROVED_FOR_PRODUCTION" ||
                                      submissionData.status ===
                                        "SUBMIT_FOR_PRODUCTION")
                                         && appData.submissions.length === 1 &&
                                      action === "DELETE"
                                  }
                                  onClick={() => callPossibleActions(action)}
                                >
                                  {availableActions[action]}
                                </Button>
                              )
                          );
                        })}
                      {(submissionData.status === "APPROVED_FOR_STAGING" ||
                        submissionData.status === "SUBMITTED_FOR_BETA" ||
                        submissionData.status === "APPROVED_FOR_BETA") &&
                        isLatestSubmission &&
                        getConfig().REACT_APP_PORTAL === "seller" && (
                          <div>
                            <IconButton
                              className="preview_button"
                              aria-controls={
                                open ? "demo-positioned-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              onClick={handleClick}
                              sx={{ p: 0 }}
                            >
                              <img
                                src={iconButton}
                                alt="preview file"
                                width={36}
                                height={36}
                              />
                            </IconButton>
                            <Menu
                              id="demo-positioned-menu"
                              aria-labelledby="demo-positioned-button"
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              slotProps={{
                                paper: {
                                  style: {},
                                },
                              }}
                            >
                              {submissionData.status ===
                                "APPROVED_FOR_STAGING" &&
                                isLatestSubmission && (
                                  <MenuItem
                                    className="icon delete"
                                    onClick={() =>
                                      callPossibleActions("REVOKE_FOR_STAGING")
                                    }
                                  >
                                    Revoke for Staging
                                  </MenuItem>
                                )}
                              {(submissionData.status ===
                                "SUBMITTED_FOR_BETA" ||
                                submissionData.status ===
                                  "APPROVED_FOR_BETA") &&
                                isLatestSubmission && (
                                  <MenuItem
                                    className="icon delete"
                                    onClick={() =>
                                      callPossibleActions("REVOKE_FOR_BETA")
                                    }
                                  >
                                    Revoke for Beta
                                  </MenuItem>
                                )}
                            </Menu>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "domain-approver" &&
                        submissionData.status === "SUBMITTED_FOR_STAGING" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true"
                              }
                              onClick={() =>
                                openModalPopUp("Reject for Staging")
                              }
                            >
                              Reject For Staging
                            </Button>
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true"
                              }
                              onClick={() =>
                                submissionData.autoPublish === true
                                  ? handleAutoPublishOpen()
                                  : openModalPopUp("Approve for Staging")
                              }
                            >
                              Approve For Staging
                            </Button>
                          </div>
                        )}
                      {(getConfig().REACT_APP_PORTAL === "global-admin" ||
                        getConfig().REACT_APP_PORTAL === "domain-approver") &&
                        submissionData.status === "IN_REVIEW" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true" || readOnly_GlobalAdmin
                              }
                              onClick={() => {
                                openModalPopUp("Reject for Production");
                              }}
                            >
                              Reject For Production
                            </Button>
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true" || readOnly_GlobalAdmin
                              }
                              variant="outlined"
                              onClick={() => {
                                  submissionData.autoPublish === true
                                    ? handleAutoPublishOpen()
                                    : openModalPopUp("Approve for Production");   
                              }}
                            >
                              Approve For Production
                            </Button>
                            <IconButton
                              sx={{
                                margin: "2px",
                                padding: "4px",
                                borderRadius: "4px",
                              }}
                              onClick={handleMoreOptionsClick}
                              aria-controls={
                                openApkValidateButton
                                  ? "more-options-menu"
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                openApkValidateButton ? "true" : undefined
                              }
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true" || readOnly_GlobalAdmin
                              }
                            >
                              <MoreVertIcon />
                            </IconButton>
                          </div>
                        )}
                      {(getConfig().REACT_APP_PORTAL === "domain-approver" ||
                        getConfig().REACT_APP_PORTAL === "global-admin") &&
                        submissionData.status === "PUBLISHED" &&
                        !thirdPartyApps && (
                          <Button
                            className={`custom-button delete_button`}
                            style={{
                              width: "fit-content",
                              height: "fit-content",
                              maxWidth: "100%",
                              textTransform: "none",
                              marginRight: "8px",
                            }}
                            disabled={
                              sessionStorage.getItem(
                                "readonly_DomainApprover"
                              ) === "true" || readOnly_GlobalAdmin
                            }
                            variant="outlined"
                            sx={{
                              "&.Mui-disabled": {
                                // color: 'rgba(0, 0, 0, 0.26) !important',
                                // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                border:
                                  "1px solid rgba(181, 11, 0, 1) !important",
                                color: "rgba(181, 11, 0, 1) !important",
                                opacity: 0.5,
                              },
                            }}
                            onClick={() => {
                              callPossibleActions("DELIST");
                            }}
                          >
                            Delist
                          </Button>
                        )}
                      {(getConfig().REACT_APP_PORTAL === "domain-approver" ||
                        getConfig().REACT_APP_PORTAL === "global-admin") &&
                        submissionData.status ===
                          "SUBMITTED_FOR_PRODUCTION" && (
                          <Button
                            className={`custom-button submitted_button`}
                            style={{
                              width: "fit-content",
                              height: "fit-content",
                              textTransform: "none",
                              minWidth: "173px",
                              backgroundColor: "#0476E2",
                              color: "#FFFFFF",
                            }}
                            sx={{
                              "&:hover": {
                                backgroundColor: "#0567C3 !important",
                              },
                              "&.Mui-disabled": {
                                border: "1px solid #1976d2",
                                color: "#1976d2",
                                opacity: 0.5,
                              },
                            }}
                            variant="outlined"
                            disabled={
                              sessionStorage.getItem(
                                "readonly_DomainApprover"
                              ) === "true" || readOnly_GlobalAdmin
                            }
                            onClick={() => {
                              callPossibleActions("IN_REVIEW");
                            }}
                          >
                            Review
                          </Button>
                        )}
                      {((getConfig().REACT_APP_PORTAL === "domain-approver" &&
                        submissionData.status === "DELISTED_BY_APPROVER") ||
                        (getConfig().REACT_APP_PORTAL === "global-admin" &&
                          submissionData.status === "DELISTED_BY_ADMIN")) && (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <Button
                            className={`custom-button delete_button`}
                            style={{
                              width: "fit-content",
                              height: "fit-content",
                              maxWidth: "100%",
                              textTransform: "none",
                              marginRight: "8px",
                            }}
                            disabled={
                              sessionStorage.getItem(
                                "readonly_DomainApprover"
                              ) === "true" || readOnly_GlobalAdmin
                            }
                            variant="outlined"
                            sx={{
                              "&.Mui-disabled": {
                                // color: 'rgba(0, 0, 0, 0.26) !important',
                                // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                border:
                                  "1px solid rgba(181, 11, 0, 1) !important",
                                color: "rgba(181, 11, 0, 1) !important",
                                opacity: 0.5,
                              },
                            }}
                            onClick={() => {
                              callPossibleActions("RELIST");
                            }}
                          >
                            Relist
                          </Button>
                        </div>
                      )}
                      {getConfig().REACT_APP_PORTAL === "domain-approver" &&
                        thirdPartyApps &&
                        submissionData.domainApprovalStatus ===
                          "DOMAIN_APPROVAL_IN_REVIEW" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true"
                              }
                              onClick={() =>
                                openModalPopUp("REJECTED_BY_DOMAIN_APPROVER")
                              }
                            >
                              Reject For Production
                            </Button>
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Domain Approval Approved")
                              }
                              disabled={
                                sessionStorage.getItem(
                                  "readonly_DomainApprover"
                                ) === "true"
                              }
                            >
                              Approve for Production
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "domain-approver" &&
                        thirdPartyApps &&
                        submissionData.domainApprovalStatus ===
                          "REJECTED_BY_DOMAIN_APPROVER" && (
                          <Button
                            className={`custom-button submitted_button`}
                            style={{
                              width: "fit-content",
                              height: "fit-content",
                              textTransform: "none",
                              minWidth: "200px",
                            }}
                            sx={{
                              "&.Mui-disabled": {
                                // color: 'rgba(0, 0, 0, 0.26) !important',
                                // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                border: "1px solid #1976d2",
                                color: "#1976d2",
                                opacity: 0.5,
                              },
                            }}
                            variant="outlined"
                            onClick={() =>
                              openModalPopUp("Domain Approval In Review")
                            }
                            disabled={
                              sessionStorage.getItem(
                                "readonly_DomainApprover"
                              ) === "true"
                            }
                          >
                            Submit To Review
                          </Button>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        submissionData.reviewStatus ===
                          "PRODUCTION_APPROVAL_IN_REVIEW" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                minWidth: "180px",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                                whiteSpace: "nowrap",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                              onClick={() =>
                                openModalPopUp("Reject for Production")
                              }
                            >
                              Reject for Production
                            </Button>
                            {submissionData.isClosedBeta === true && (
                              <Button
                                className={`custom-button submitted_button`}
                                style={{
                                  width: "fit-content",
                                  height: "fit-content",
                                  textTransform: "none",
                                  minWidth: "180px",
                                  paddingLeft: "8px",
                                  paddingRight: "8px",
                                  marginRight: "8px",
                                }}
                                sx={{
                                  "&.Mui-disabled": {
                                    border: "1px solid #1976d2",
                                    color: "#1976d2",
                                    opacity: 0.5,
                                  },
                                }}
                                variant="outlined"
                                onClick={() =>
                                  openModalPopUp("Move to In-Review")
                                }
                                disabled={
                                  sessionStorage.getItem(
                                    "readonly_OemAdmin"
                                  ) === "true"
                                }
                              >
                                Move to In-Review
                              </Button>
                            )}
                            {(submissionData.reviewStatus ===
                              "PRODUCTION_APPROVAL_IN_REVIEW" ||
                              submissionData.reviewStatus ===
                                "STAGING_APPROVAL_IN_REVIEW" ||
                              submissionData.reviewStatus ===
                                "APPROVED_FOR_BETA") &&
                              submissionData.isClosedBeta !== true && (
                                <Button
                                  className={`custom-button submitted_button`}
                                  style={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    textTransform: "none",
                                    minWidth: "180px",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    marginRight: "8px",
                                  }}
                                  sx={{
                                    "&.Mui-disabled": {
                                      // color: 'rgba(0, 0, 0, 0.26) !important',
                                      // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                      border: "1px solid #1976d2",
                                      color: "#1976d2",
                                      opacity: 0.5,
                                    },
                                  }}
                                  variant="outlined"
                                  onClick={() =>
                                    openModalPopUp("Approve for Closed Beta")
                                  }
                                  disabled={
                                    sessionStorage.getItem(
                                      "readonly_OemAdmin"
                                    ) === "true"
                                  }
                                >
                                  Approve for Closed Beta
                                </Button>
                              )}
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Approve for Production")
                              }
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                            >
                              Approve for Production
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        submissionData.reviewStatus ===
                          "STAGING_APPROVAL_IN_REVIEW" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                minWidth: "180px",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                                whiteSpace: "nowrap",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                              onClick={() =>
                                openModalPopUp("Reject for Staging")
                              }
                            >
                              Reject for Staging
                            </Button>
                            {submissionData.isClosedBeta === true && (
                              <Button
                                className={`custom-button submitted_button`}
                                style={{
                                  width: "fit-content",
                                  height: "fit-content",
                                  textTransform: "none",
                                  minWidth: "180px",
                                  paddingLeft: "8px",
                                  paddingRight: "8px",
                                  marginRight: "8px",
                                }}
                                sx={{
                                  "&.Mui-disabled": {
                                    border: "1px solid #1976d2",
                                    color: "#1976d2",
                                    opacity: 0.5,
                                  },
                                }}
                                variant="outlined"
                                onClick={() =>
                                  openModalPopUp("Move to In-Review")
                                }
                                disabled={
                                  sessionStorage.getItem(
                                    "readonly_OemAdmin"
                                  ) === "true"
                                }
                              >
                                Move to In-Review
                              </Button>
                            )}
                            {(submissionData.reviewStatus ===
                              "PRODUCTION_APPROVAL_IN_REVIEW" ||
                              submissionData.reviewStatus ===
                                "STAGING_APPROVAL_IN_REVIEW" ||
                              submissionData.reviewStatus ===
                                "APPROVED_FOR_BETA") &&
                              submissionData.isClosedBeta !== true && (
                                <Button
                                  className={`custom-button submitted_button`}
                                  style={{
                                    width: "fit-content",
                                    height: "fit-content",
                                    textTransform: "none",
                                    minWidth: "180px",
                                    paddingLeft: "8px",
                                    paddingRight: "8px",
                                    marginRight: "8px",
                                  }}
                                  sx={{
                                    "&.Mui-disabled": {
                                      // color: 'rgba(0, 0, 0, 0.26) !important',
                                      // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                      border: "1px solid #1976d2",
                                      color: "#1976d2",
                                      opacity: 0.5,
                                    },
                                  }}
                                  variant="outlined"
                                  onClick={() =>
                                    openModalPopUp("Approve for Closed Beta")
                                  }
                                  disabled={
                                    sessionStorage.getItem(
                                      "readonly_OemAdmin"
                                    ) === "true"
                                  }
                                >
                                  Approve for Closed Beta
                                </Button>
                              )}
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Approve for Staging")
                              }
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                            >
                              Approve for Staging
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        submissionData.reviewStatus === "APPROVED_FOR_BETA" &&
                        submissionData.isClosedBeta !== true && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "180px",
                                paddingLeft: "8px",
                                paddingRight: "8px",
                                marginRight: "8px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Approve for Closed Beta")
                              }
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                            >
                              Approve for Closed Beta
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        (submissionData.reviewStatus === "DELIST_AT_STAGING" ||
                          submissionData.reviewStatus ===
                            "FORCE_UNINSTALL_AT_STAGING" ||
                          submissionData.reviewStatus ===
                            "REJECTED_AT_STAGING") && (
                          <div>
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Approve for Staging")
                              }
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                            >
                              Approve for Staging
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        submissionData.reviewStatus ===
                          "STAGING_APPROVAL_APPROVED" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                              onClick={() =>
                                openModalPopUp("Delist from Staging")
                              }
                            >
                              Delist from Staging
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        submissionData.reviewStatus ===
                          "PRODUCTION_APPROVAL_APPROVED" && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button delete_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                maxWidth: "100%",
                                textTransform: "none",
                                marginRight: "8px",
                              }}
                              variant="outlined"
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border:
                                    "1px solid rgba(181, 11, 0, 1) !important",
                                  color: "rgba(181, 11, 0, 1) !important",
                                  opacity: 0.5,
                                },
                              }}
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                              onClick={() =>
                                openModalPopUp("Delist from Production")
                              }
                            >
                              Delist from Production
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "oem-admin" &&
                        (submissionData.reviewStatus ===
                          "DELIST_AT_PRODUCTION" ||
                          submissionData.reviewStatus ===
                            "FORCE_UNINSTALL_AT_PRODUCTION" ||
                          submissionData.reviewStatus ===
                            "REJECTED_AT_PRODUCTION") && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-around",
                            }}
                          >
                            <Button
                              className={`custom-button submitted_button`}
                              style={{
                                width: "fit-content",
                                height: "fit-content",
                                textTransform: "none",
                                minWidth: "200px",
                              }}
                              sx={{
                                "&.Mui-disabled": {
                                  // color: 'rgba(0, 0, 0, 0.26) !important',
                                  // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                  border: "1px solid #1976d2",
                                  color: "#1976d2",
                                  opacity: 0.5,
                                },
                              }}
                              variant="outlined"
                              onClick={() =>
                                openModalPopUp("Approve for Production")
                              }
                              disabled={
                                sessionStorage.getItem("readonly_OemAdmin") ===
                                "true"
                              }
                            >
                              Approve for Production
                            </Button>
                          </div>
                        )}
                      {getConfig().REACT_APP_PORTAL === "global-admin" &&
                        submissionData.status === "APPROVED_FOR_PRODUCTION" && (
                          <Button
                            className={`custom-button submitted_button`}
                            style={{
                              width: "fit-content",
                              height: "fit-content",
                              textTransform: "none",
                              minWidth: "200px",
                            }}
                            sx={{
                              "&.Mui-disabled": {
                                // color: 'rgba(0, 0, 0, 0.26) !important',
                                // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                                border: "1px solid #1976d2",
                                color: "#1976d2",
                                opacity: 0.5,
                              },
                            }}
                            variant="outlined"
                            onClick={() => {
                              handleNotifyDeveloper();
                            }}
                          >
                            Notify Developer
                          </Button>
                        )}
                    </Stack>
                  </div>
                )}
              </div>
            )}
            {submissionData &&
              Object.keys(submissionData).length > 0 &&
              sessionStorage.getItem("customPortal") !== "oem-admin" && (
                <Dialog
                  sx={{
                    "& .MuiDialog-paper": { width: "80%", maxHeight: 435 },
                  }}
                  maxWidth="xs"
                  open={openDelistDialog}
                >
                  <DialogTitle
                    disabled={
                      sessionStorage.getItem("readonly_OemAdmin") === "true"
                    }
                  >
                    Delist {submissionData.descriptions[0].applicationName}
                  </DialogTitle>
                  <DialogContent dividers>
                    <p className="delist-text">
                      The action will remove the app from active distribution on
                      all the head units and
                    </p>
                    <p className="delist-text">
                      make it un accessible from all the current users
                    </p>
                    <div>
                      <p
                        style={{
                          "font-size": "14px",
                          "font-weight": 400,
                          "line-height": "16.41px",
                          "text-align": "left",
                          color: "rgba(113, 114, 115, 1)",
                        }}
                      >
                        Reason for delisted *
                      </p>
                      <TextField
                        sx={{
                          "&.MuiFormControl-root": {
                            width: "82%",
                          },
                          "&.MuiFormHelperText-root": {
                            display: "flex",
                            justifyContent: "flex-end",
                          },
                        }}
                        slotProps={{
                          htmlInput: {
                            maxLength: 80,
                          },
                          formHelperText: {
                            sx: {
                              display: "flex",
                              justifyContent: "flex-end",
                            },
                          },
                          inputLabel: {
                            shrink: false,
                            sx: {
                              fontSize: "14px",
                              fontWeight: 400,
                              lineHeight: "16.41px",
                              textAlign: "left",
                              color: "#b50b00 !important",
                            },
                          },
                        }}
                        label={delistReason === null}
                        className="input-fields"
                        id="outlined-basic"
                        type="text"
                        variant="outlined"
                        defaultValue={delistReason}
                        value={delistReason}
                        onChange={($event) => handleChangeDelistValue($event)}
                      />
                    </div>
                    <div style={{ marginLeft: "-10px !important" }}>
                      <Checkbox
                        label="Default value"
                        checked={forceInstall}
                        onChange={($event) => handleForceInstallAll($event)}
                        size="small"
                      />
                      <span className="include-all">Force Unistall</span>
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button
                      className={`custom-button submitted_button`}
                      style={{
                        width: "fit-content",
                        height: "fit-content",
                        maxWidth: "100%",
                        textTransform: "none",
                      }}
                      variant="outlined"
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      className={`custom-button delete_button`}
                      style={{
                        width: "fit-content",
                        height: "fit-content",
                        maxWidth: "100%",
                        textTransform: "none",
                      }}
                      sx={{
                        "&.Mui-disabled": {
                          // color: 'rgba(0, 0, 0, 0.26) !important',
                          // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                          border: "1px solid rgba(181, 11, 0, 1) !important",
                          color: "rgba(181, 11, 0, 1) !important",
                          opacity: 0.5,
                        },
                      }}
                      variant="outlined"
                      disabled={delistReason === null || delistReason === ""}
                      onClick={callDelist}
                    >
                      Delists
                    </Button>
                  </DialogActions>
                </Dialog>
              )}

            <Dialog
              sx={{
                "& .MuiDialog-paper": {
                  width: "90%",
                  maxHeight: 435,
                  maxWidth: 539,
                },
              }}
              maxWidth="xs"
              open={openDsaDialog}
            >
              <DialogTitle sx={{ pb: 0 }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "24px",
                  }}
                >
                  <h2 className="dsa-dialog-title">
                    Confirm Submission
                  </h2>
                  <IconButton onClick={handleDsaCancel} sx={{ p: 0 }}>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.6 24L8 22.4L14.4 16L8 9.6L9.6 8L16 14.4L22.4 8L24 9.6L17.6 16L24 22.4L22.4 24L16 17.6L9.6 24Z"
                        fill="#121415"
                        fillOpacity="0.6"
                      />
                    </svg>
                  </IconButton>
                </div>
              </DialogTitle>
              <DialogContent sx={{ pt: "24px !important" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                  }}
                >
                  <Checkbox
                    label="Default value"
                    checked={dsaComplaint}
                    onChange={($event) => handleDsaomplaint($event)}
                    size="small"
                    sx={{
                      p: 0,
                      mt: "2px",
                      mr: "8px",
                      flexShrink: 0,
                    }}
                  />
                  <p className="dsa-popup-text">
                    Your app is configured for the European region and all
                    required{" "}
                    <a
                      style={{
                        color: "#0476E2",
                        fontSize: "14px",
                        fontWeight: "700",
                        letterSpacing: "0.15px",
                        textDecoration: "underline",
                      }}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="digital-service-act-text"
                      href="https://commission.europa.eu/strategy-and-policy/priorities-2019-2024/europe-fit-digital-age/digital-services-act_en"
                    >
                      Digital Services Act (DSA)
                    </a>{" "}
                    information is complete. By confirming, you agree that
                    your app complies with all applicable DSA regulations.
                  </p>
                </div>
                <p className="dsa-popu-two-text">
                  <span
                    style={{
                      fontWeight: 800,
                      fontSize: "14px",
                      letterSpacing: "0.15px",
                    }}
                  >
                    Note:
                  </span>{" "}
                  Failure to comply with the DSA may result in legal
                  consequences.
                </p>
              </DialogContent>
              <DialogActions sx={{ padding: "0 24px 24px" }}>
                <Button
                  className={`custom-button cancel-button`}
                  variant="outlined"
                  onClick={handleDsaCancel}
                  sx={{
                    width: "fit-content",
                    height: "fit-content",
                    "max-width": "100%",
                    "text-transform": "none",
                    "background-color": "#1214151A !important",
                    color: "#2A2C2D !important",
                    border: "0px",
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className={`custom-button submitted_button`}
                  sx={{
                    width: "fit-content",
                    height: "fit-content",
                    maxWidth: "100%",
                    textTransform: "none",
                    backgroundColor: "#0476E2 !important",
                    color: "white !important",
                    "&.Mui-disabled": {
                      // color: 'rgba(0, 0, 0, 0.26) !important',
                      // border: '1px solid rgba(0, 0, 0, 0.12) !important'
                      border: "1px solid #C2DFFB !important",
                      color: "white !important",
                      background: "#C2DFFB !important",
                      opacity: 0.5,
                    },
                  }}
                  variant="outlined"
                  disabled={!dsaComplaint}
                  onClick={() => callDsaComplaintSubmit()}
                >
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
            <Modal
              open={openPopuModal}
              onClose={handlePopupModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "600px",
                margin: "auto",
              }}
            >
              <Box className="qaReportPopUp" sx={{ width: "900px" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "10px",
                  }}
                >
                  <Typography
                    id="modal-modal-title"
                    fontWeight={"500"}
                    marginLeft={"13px"}
                    sx={{ color: "#121415", fontSize: "22px" }}
                  >
                    {titleModalPopup}
                  </Typography>
                  <IconButton onClick={handlePopupModalClose} sx={{ p: 0 }}>
                    <IconButton>
                      {" "}
                      <CloseIcon />{" "}
                    </IconButton>
                  </IconButton>
                </div>

                <div>
                  <ApproveApplicationPopUp
                    handlePopupModalClose={handlePopupModalClose}
                    nextReviewStatus={nextReviewStatus}
                    submissionData={submissionData}
                  />
                </div>
              </Box>
            </Modal>
            <Dialog
              open={openAutoPublishDialog}
              onClose={handleAutoPublishClose}
              maxWidth="sm"
              fullWidth
              sx={{
                "& .MuiDialog-paper": {
                  borderRadius: "12px",
                  padding: "8px",
                  minHeight: "200px",
                },
              }}
            >
              <DialogTitle
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "16px 24px",
                  fontSize: "22px",
                  fontWeight: "500",
                  color: "#121415",
                }}
              >
                Application-Auto Publish
                <IconButton
                  onClick={handleAutoPublishClose}
                  sx={{
                    color: "#121415",
                    opacity: 0.6,
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </DialogTitle>

              <DialogContent
                sx={{
                  padding: "0 24px 16px 24px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    color: "#121415",
                    lineHeight: "24px",
                  }}
                >
                  This application will be automatically published after the
                  Approval Process.
                </Typography>
              </DialogContent>

              <DialogActions
                sx={{
                  padding: "16px 24px",
                  gap: "12px",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  onClick={handleAutoPublishClose}
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    borderRadius: "24px",
                    padding: "10px 24px",
                    fontSize: "16px",
                    fontWeight: "500",
                    color: "#0476E2",
                    borderColor: "#0476E2",
                    "&:hover": {
                      borderColor: "#0476E2",
                      backgroundColor: "rgba(4, 118, 226, 0.04)",
                    },
                  }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleAutoPublishProceed}
                  variant="contained"
                  sx={{
                    textTransform: "none",
                    borderRadius: "24px",
                    padding: "10px 24px",
                    fontSize: "16px",
                    fontWeight: "500",
                    backgroundColor: "#0476E2",
                    "&:hover": {
                      backgroundColor: "#0360C4",
                    },
                  }}
                >
                  Proceed
                </Button>
              </DialogActions>
            </Dialog>
          </section>
        </Grid>
      </Grid>
      <PopupDialog
        openErrorPopup={openErrorPopup}
        errorMessage={errorMessage}
        headerMessage={headerMessage}
        componentName={componentName}
        onClose={() => setOpenErrorPopup(false)}
      />

      <Menu
        id="more-options-menu"
        anchorEl={anchorEl}
        open={openApkValidateButton}
        onClose={handleMoreOptionsClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPaper-root": {
            marginTop: "4px",
          },
        }}
      >
        <MenuItem onClick={handleValidateClick}>Validate</MenuItem>
      </Menu>

      {/* Add this Snackbar component */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default ListingHeader;

ListingHeader.propTypes = {
  checkAll: PropTypes.bool,
  callPostSubmissionRequest: PropTypes.func,
  calPostApplicationNewRelase: PropTypes.func,
  postCallTheNewSubmission: PropTypes.func,
  createNewRelase: PropTypes.bool,
};
